if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');

      // Calcular offset inicial una sola vez para header transparente
      if (this.classList.contains('header-sticky--active')) {
        // Para headers transparentes (position: absolute), el offset es 0
        // Para headers normales, usar la posición inicial
        this.stickyOffset = this.classList.contains('transparent--true') ? 0 : this.offsetTop;
      }

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });
      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      // Calcular altura de announcement bars (top y countdown)
      const announcementTopSection = document.querySelector('.announcement-bar-top-section');
      const countdownBarSection = document.querySelector('.announcement-bar-countdown-section');
      
      if (announcementTopSection || countdownBarSection) {
        // Ejecutar inmediatamente al cargar
        this.setAnnouncementHeight();
        
        // Ejecutar en scroll
        window.addEventListener('scroll', this.setAnnouncementHeight.bind(this), {
          passive: true
        });
        
        // Ejecutar en resize
        window.addEventListener('resize', debounce(this.setAnnouncementHeight.bind(this), 100), {
          passive: true
        });
        
        // Ejecutar después de que las fuentes estén cargadas
        document.fonts.ready.then(() => {
          this.setAnnouncementHeight();
        });
        
        // Ejecutar después de que el DOM esté completamente cargado
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.setAnnouncementHeight();
          });
        } else {
          // Si ya está cargado, ejecutar después de un pequeño delay para asegurar que los elementos estén renderizados
          setTimeout(() => {
            this.setAnnouncementHeight();
          }, 100);
        }
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        // Usar offset calculado al inicio en lugar de recalcular cada vez
        const offset = this.stickyOffset || 0;
        this.classList.toggle('is-sticky', window.scrollY > offset);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-top-section');
      const countdown_bar = document.querySelector('.announcement-bar-countdown-section');
      let h = 0;
      let top_h = 0;
      
      // Calcular altura del announcement bar top solo si existe y está visible
      if (a_bar) {
        // Usar offsetHeight en lugar de clientHeight para incluir bordes
        top_h = a_bar.offsetHeight || a_bar.clientHeight;
        if (top_h > 0) {
        h += top_h;
        document.documentElement.style.setProperty('--announcement-top-height', top_h + 'px');
        } else {
          // Si la altura es 0, establecer a 0 explícitamente
          document.documentElement.style.setProperty('--announcement-top-height', '0px');
        }
      } else {
        // Si no existe, establecer a 0
        document.documentElement.style.setProperty('--announcement-top-height', '0px');
      }
      
      // Calcular altura del countdown bar solo si existe y está visible
      if (countdown_bar) {
        const countdown_h = countdown_bar.offsetHeight || countdown_bar.clientHeight;
        if (countdown_h > 0) {
          h += countdown_h;
        }
      }
      
      // Establecer la altura total
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}